import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=fe9e339c&scoped=true&"
import script from "./Translations.vue?vue&type=script&lang=ts&"
export * from "./Translations.vue?vue&type=script&lang=ts&"
import style0 from "./Translations.vue?vue&type=style&index=0&id=fe9e339c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9e339c",
  null
  
)

export default component.exports